// Privacy policy and terms of use, published at /{language}/privacy and /{language}/terms.
import { PUBLIC_LANGUAGES } from "./public-content.js";

export const LEGAL_UPDATED = "2026-10-19";
export const LEGAL_ALIASES = {
  "/privacy": "/uz/privacy",
  "/terms": "/uz/terms",
};

export const LEGAL_UI = {
  uz: {
    privacy: "Maxfiylik siyosati",
    terms: "Foydalanish shartlari",
    updated: "Oxirgi yangilanish",
    legal: "Huquqiy ma’lumot",
  },
  en: {
    privacy: "Privacy policy",
    terms: "Terms of use",
    updated: "Last updated",
    legal: "Legal",
  },
  ru: {
    privacy: "Политика конфиденциальности",
    terms: "Условия использования",
    updated: "Последнее обновление",
    legal: "Правовая информация",
  },
};

export const LEGAL_DOCS = {
  privacy: {
    uz: {
      title: "Maxfiylik siyosati — DayX",
      description:
        "DayX qaysi ma’lumotlarni saqlaydi, ulardan qanday foydalanadi va siz ularni qanday boshqarishingiz mumkin.",
      heading: "Maxfiylik siyosati",
      intro:
        "DayX — kunlik reja, diqqat taymeri va imtihon sanalari uchun ish maydoni. Biz faqat xizmat ishlashi uchun zarur ma’lumotlarni saqlaymiz, ularni sotmaymiz va reklama uchun ishlatmaymiz.",
      sections: [
        [
          "Qaysi ma’lumotlarni saqlaymiz",
          [
            "Hisob: email manzilingiz va parolingizning shifrlangan xeshi (parolning o‘zi saqlanmaydi). Google orqali kirsangiz — Google hisobingiz identifikatori va emailingiz.",
            "Ish maydoni: rejalaringiz, bajarilgan belgilar, imtihon sanalari, taymer va ko‘rinish sozlamalari.",
            "Faollik: kirish vaqti, ochilgan sahifa va kirish usuli. Bu xizmatning ishlashini kuzatish uchun ishlatiladi.",
            "Xabarlar: “Xato haqida yozish” orqali yuborgan matningiz, sahifa nomi, til va ekran o‘lchami.",
            "Texnik ma’lumot: IP manzil faqat suiiste’mollikdan himoya qilish (urinishlar sonini cheklash) uchun qisqa vaqt xotirada turadi.",
          ],
        ],
        [
          "Cookie va brauzer xotirasi",
          [
            "Biz faqat bitta zarur cookie ishlatamiz: hisobingizda qolishingiz uchun sessiya cookie’si (30 kun). Reklama yoki kuzatuv cookie’lari yo‘q.",
            "Mehmon rejimidagi rejalar, til va ko‘rinish sozlamalari brauzeringiz xotirasida (localStorage) saqlanadi.",
          ],
        ],
        [
          "Ma’lumotlardan qanday foydalanamiz",
          [
            "Rejalaringizni saqlash va barcha qurilmalaringizda ko‘rsatish.",
            "Hisobga kirish, parolni tiklash va emailni tasdiqlash xatlarini yuborish.",
            "Xatolarni tuzatish va xizmatni yaxshilash.",
          ],
        ],
        [
          "Kimlar bilan ulashamiz",
          [
            "Ma’lumotlaringizni sotmaymiz. Faqat xizmatni ishlatuvchi provayderlar ishtirok etadi: Railway (server va ma’lumotlar bazasi), Resend (xatlarni yetkazish), Google (agar Google bilan kirishni tanlasangiz).",
            "Qonun talab qilgan hollarda ma’lumot vakolatli organlarga berilishi mumkin.",
          ],
        ],
        [
          "Saqlash muddati va xavfsizlik",
          [
            "Ma’lumotlar hisobingiz mavjud ekan saqlanadi. Zaxira nusxalar 14 kungacha saqlanadi, shuning uchun o‘chirilgan ma’lumot zaxiralardan 14 kun ichida butunlay yo‘qoladi.",
            "Ulanish HTTPS orqali shifrlanadi, parollar scrypt bilan xeshlanadi, kirish urinishlari cheklangan.",
          ],
        ],
        [
          "Sizning huquqlaringiz",
          [
            "Ma’lumotlaringizni istalgan vaqtda Sozlamalar → Ma’lumotlarni yuklab olish orqali JSON fayl ko‘rinishida olishingiz mumkin.",
            "Hisobingizni va unga tegishli barcha ma’lumotlarni Hisob oynasidagi “Hisobni o‘chirish” tugmasi bilan butunlay o‘chirishingiz mumkin.",
            "Savollar uchun ilovadagi “Xato haqida yozish” tugmasidan foydalaning.",
          ],
        ],
        [
          "Bolalar",
          [
            "DayX 13 yoshdan kichik bolalar uchun mo‘ljallanmagan. 13–18 yoshli foydalanuvchilar ota-onasi yoki vasiysi roziligi bilan foydalanishi kerak.",
          ],
        ],
        [
          "O‘zgarishlar",
          [
            "Bu siyosat o‘zgarsa, sahifadagi sanani yangilaymiz. Muhim o‘zgarishlar haqida ilova ichida xabar beramiz.",
          ],
        ],
      ],
    },
    en: {
      title: "Privacy policy — DayX",
      description:
        "What DayX stores, how it is used and how you stay in control of your data.",
      heading: "Privacy policy",
      intro:
        "DayX is a workspace for daily plans, focus sessions and exam dates. We store only what the service needs to work. We never sell your data or use it for advertising.",
      sections: [
        [
          "What we store",
          [
            "Account: your email address and a salted hash of your password (never the password itself). If you sign in with Google, your Google account identifier and email.",
            "Workspace: your plans, completion marks, exam dates, timer and appearance settings.",
            "Activity: sign-in time, the page you open and the sign-in method, used to keep the service running well.",
            "Reports: text you send through “Report an issue”, plus the page, language and screen size.",
            "Technical data: your IP address is held briefly in memory only to limit repeated attempts and prevent abuse.",
          ],
        ],
        [
          "Cookies and browser storage",
          [
            "We use one essential cookie: a session cookie that keeps you signed in (30 days). There are no advertising or tracking cookies.",
            "Guest plans, language and appearance preferences are kept in your browser’s local storage.",
          ],
        ],
        [
          "How we use data",
          [
            "To save your plans and show them on all your devices.",
            "To sign you in and send password reset and email confirmation messages.",
            "To fix problems and improve the service.",
          ],
        ],
        [
          "Who we share data with",
          [
            "We do not sell data. Only providers that run the service process it: Railway (servers and database), Resend (email delivery) and Google (if you choose Google sign-in).",
            "We may disclose information when the law requires it.",
          ],
        ],
        [
          "Retention and security",
          [
            "Data is kept while your account exists. Backups are kept for up to 14 days, so deleted data disappears from backups within 14 days.",
            "Connections use HTTPS, passwords are hashed with scrypt and sign-in attempts are rate limited.",
          ],
        ],
        [
          "Your rights",
          [
            "Download your data at any time from Settings → Export data as a JSON file.",
            "Permanently delete your account and all of its data with “Delete account” in the Account window.",
            "For questions, use the “Report an issue” button in the app.",
          ],
        ],
        [
          "Children",
          [
            "DayX is not intended for children under 13. Users aged 13–18 should use it with permission from a parent or guardian.",
          ],
        ],
        [
          "Changes",
          [
            "When this policy changes we update the date on this page and announce important changes in the app.",
          ],
        ],
      ],
    },
    ru: {
      title: "Политика конфиденциальности — DayX",
      description:
        "Какие данные хранит DayX, как они используются и как вы можете ими управлять.",
      heading: "Политика конфиденциальности",
      intro:
        "DayX — пространство для планов на день, фокус-сессий и дат экзаменов. Мы храним только то, что нужно для работы сервиса, не продаём данные и не используем их для рекламы.",
      sections: [
        [
          "Какие данные мы храним",
          [
            "Аккаунт: ваш email и хеш пароля с солью (сам пароль не хранится). При входе через Google — идентификатор вашего аккаунта Google и email.",
            "Пространство: ваши планы, отметки о выполнении, даты экзаменов, настройки таймера и оформления.",
            "Активность: время входа, открытая страница и способ входа — для контроля работы сервиса.",
            "Сообщения: текст, отправленный через «Сообщить об ошибке», а также страница, язык и размер экрана.",
            "Технические данные: IP-адрес кратковременно хранится в памяти только для ограничения повторных попыток и защиты от злоупотреблений.",
          ],
        ],
        [
          "Cookie и хранилище браузера",
          [
            "Мы используем один необходимый cookie — сессионный, чтобы вы оставались в аккаунте (30 дней). Рекламных и отслеживающих cookie нет.",
            "Планы гостевого режима, язык и оформление хранятся в локальном хранилище браузера.",
          ],
        ],
        [
          "Как мы используем данные",
          [
            "Чтобы сохранять ваши планы и показывать их на всех ваших устройствах.",
            "Чтобы выполнять вход и отправлять письма для сброса пароля и подтверждения email.",
            "Чтобы исправлять ошибки и улучшать сервис.",
          ],
        ],
        [
          "С кем мы делимся данными",
          [
            "Мы не продаём данные. Их обрабатывают только провайдеры, обеспечивающие работу сервиса: Railway (серверы и база данных), Resend (доставка писем) и Google (если вы выбрали вход через Google).",
            "Мы можем раскрыть информацию, если этого требует закон.",
          ],
        ],
        [
          "Срок хранения и безопасность",
          [
            "Данные хранятся, пока существует ваш аккаунт. Резервные копии хранятся до 14 дней, поэтому удалённые данные исчезают из копий в течение 14 дней.",
            "Соединение защищено HTTPS, пароли хешируются scrypt, число попыток входа ограничено.",
          ],
        ],
        [
          "Ваши права",
          [
            "Скачайте свои данные в любой момент: Настройки → Экспорт данных (файл JSON).",
            "Удалите аккаунт и все его данные навсегда кнопкой «Удалить аккаунт» в окне аккаунта.",
            "С вопросами обращайтесь через кнопку «Сообщить об ошибке» в приложении.",
          ],
        ],
        [
          "Дети",
          [
            "DayX не предназначен для детей младше 13 лет. Пользователи 13–18 лет должны пользоваться сервисом с разрешения родителя или опекуна.",
          ],
        ],
        [
          "Изменения",
          [
            "При изменении политики мы обновим дату на этой странице и сообщим о важных изменениях в приложении.",
          ],
        ],
      ],
    },
  },
  terms: {
    uz: {
      title: "Foydalanish shartlari — DayX",
      description: "DayX xizmatidan foydalanish qoidalari.",
      heading: "Foydalanish shartlari",
      intro:
        "DayX’dan foydalanish orqali siz quyidagi shartlarga rozilik bildirasiz. Iltimos, ularni diqqat bilan o‘qing.",
      sections: [
        [
          "Xizmat",
          [
            "DayX kunlik va haftalik reja tuzish, bajarilgan ishlarni belgilash, diqqat taymeri va imtihon sanalarini kuzatish imkonini beradi. Xizmatni mehmon sifatida yoki hisob ochib ishlatishingiz mumkin.",
          ],
        ],
        [
          "Hisobingiz",
          [
            "To‘g‘ri email manzilidan foydalaning va parolingizni boshqalarga bermang. Hisobingizda bajarilgan harakatlar uchun o‘zingiz javobgarsiz.",
            "Hisobingizni istalgan vaqtda o‘chirishingiz mumkin.",
          ],
        ],
        [
          "Sizning ma’lumotlaringiz",
          [
            "Siz yaratgan rejalar va yozuvlar sizga tegishli. Biz ulardan faqat xizmatni ko‘rsatish uchun foydalanamiz — batafsil Maxfiylik siyosatida.",
          ],
        ],
        [
          "Taqiqlangan harakatlar",
          [
            "Xizmatni buzishga, boshqalarning hisobiga ruxsatsiz kirishga, avtomatlashtirilgan so‘rovlar bilan ortiqcha yuklashga yoki qonunga zid maqsadlarda foydalanishga urinmang.",
            "Bu qoidalar buzilsa, hisob to‘xtatilishi mumkin.",
          ],
        ],
        [
          "To‘lovli imkoniyatlar",
          [
            "Hozircha DayX bepul. Kelajakda ba’zi imkoniyatlar pullik bo‘lishi mumkin. Bunday holda narx va shartlar to‘lovdan oldin aniq ko‘rsatiladi.",
          ],
        ],
        [
          "Kafolat va javobgarlik",
          [
            "Xizmat “boricha” taqdim etiladi. Uni ishonchli ishlatishga harakat qilamiz va har kuni zaxira nusxa olamiz, ammo uzilishlar yoki xatolar bo‘lmasligiga kafolat bermaymiz. Muhim ma’lumotlaringizni vaqti-vaqti bilan yuklab olib qo‘ying.",
            "Qonun ruxsat bergan darajada, xizmatdan foydalanish natijasida yuzaga kelgan bilvosita zararlar uchun javobgar emasmiz.",
          ],
        ],
        [
          "O‘zgarishlar va qonunchilik",
          [
            "Shartlarni yangilashimiz mumkin. Yangi sana ushbu sahifada ko‘rsatiladi va muhim o‘zgarishlar ilovada e’lon qilinadi.",
            "Bu shartlar O‘zbekiston Respublikasi qonunchiligiga muvofiq tartibga solinadi.",
          ],
        ],
      ],
    },
    en: {
      title: "Terms of use — DayX",
      description: "The rules for using the DayX service.",
      heading: "Terms of use",
      intro:
        "By using DayX you agree to these terms. Please read them carefully.",
      sections: [
        [
          "The service",
          [
            "DayX lets you plan days and weeks, mark completed work, run focus sessions and track exam dates. You can use it as a guest or with an account.",
          ],
        ],
        [
          "Your account",
          [
            "Use an email address you own and keep your password private. You are responsible for activity in your account.",
            "You can delete your account at any time.",
          ],
        ],
        [
          "Your content",
          [
            "The plans and notes you create belong to you. We use them only to provide the service, as described in the Privacy policy.",
          ],
        ],
        [
          "Acceptable use",
          [
            "Do not try to disrupt the service, access other people’s accounts, overload it with automated requests or use it for unlawful purposes.",
            "Accounts that break these rules may be suspended.",
          ],
        ],
        [
          "Paid features",
          [
            "DayX is currently free. Some features may become paid in the future; prices and terms will always be shown clearly before you pay.",
          ],
        ],
        [
          "Warranty and liability",
          [
            "The service is provided “as is”. We work to keep it reliable and back it up daily, but cannot guarantee it will be free of interruptions or errors. Export important data from time to time.",
            "To the extent the law allows, we are not liable for indirect damages arising from use of the service.",
          ],
        ],
        [
          "Changes and governing law",
          [
            "We may update these terms. The new date appears on this page and important changes are announced in the app.",
            "These terms are governed by the laws of the Republic of Uzbekistan.",
          ],
        ],
      ],
    },
    ru: {
      title: "Условия использования — DayX",
      description: "Правила использования сервиса DayX.",
      heading: "Условия использования",
      intro:
        "Пользуясь DayX, вы соглашаетесь с этими условиями. Пожалуйста, внимательно прочитайте их.",
      sections: [
        [
          "Сервис",
          [
            "DayX помогает планировать дни и недели, отмечать выполненную работу, проводить фокус-сессии и следить за датами экзаменов. Пользоваться можно как гость или с аккаунтом.",
          ],
        ],
        [
          "Ваш аккаунт",
          [
            "Используйте свой email и не передавайте пароль другим. Вы отвечаете за действия в своём аккаунте.",
            "Вы можете удалить аккаунт в любой момент.",
          ],
        ],
        [
          "Ваши данные",
          [
            "Созданные вами планы и записи принадлежат вам. Мы используем их только для работы сервиса, как описано в Политике конфиденциальности.",
          ],
        ],
        [
          "Запрещённые действия",
          [
            "Не пытайтесь нарушить работу сервиса, получить доступ к чужим аккаунтам, перегружать его автоматическими запросами или использовать его в незаконных целях.",
            "Аккаунты, нарушающие эти правила, могут быть заблокированы.",
          ],
        ],
        [
          "Платные функции",
          [
            "Сейчас DayX бесплатен. В будущем некоторые функции могут стать платными; цена и условия всегда будут показаны до оплаты.",
          ],
        ],
        [
          "Гарантии и ответственность",
          [
            "Сервис предоставляется «как есть». Мы стараемся обеспечивать надёжную работу и ежедневно делаем резервные копии, но не гарантируем отсутствие перебоев и ошибок. Периодически экспортируйте важные данные.",
            "В пределах, разрешённых законом, мы не несём ответственности за косвенные убытки от использования сервиса.",
          ],
        ],
        [
          "Изменения и применимое право",
          [
            "Мы можем обновлять условия. Новая дата появится на этой странице, о важных изменениях мы сообщим в приложении.",
            "Условия регулируются законодательством Республики Узбекистан.",
          ],
        ],
      ],
    },
  },
};

export function legalPage(path) {
  const [, language, id, extra] = path.split("/");
  if (extra !== undefined || !PUBLIC_LANGUAGES.includes(language)) return null;
  const doc = LEGAL_DOCS[id]?.[language];
  return doc ? { language, id, copy: doc } : null;
}

export function legalPaths() {
  return PUBLIC_LANGUAGES.flatMap((language) =>
    Object.keys(LEGAL_DOCS).map((id) => `/${language}/${id}`),
  );
}
